import React, { useEffect } from 'react';
import { Container, showAlert } from '../../../components';
import Table from '../../../components/common/table/Table';
import { usePaymentReminder } from '@/context/paymentReminderContext/PaymentReminderContextProvider';
import {
  ModalProvider,
  useModal,
} from '../../../components/common/modal/ModalContext';
import DetailTable from './DetailTable';

const EmailLogs = () => {
  const {
    getLogsListAPI,
    logData,
    pageSize,
    currentPage,
    setCurrentPage,
    totalElements,
  } = usePaymentReminder();

  useEffect(() => {
    getLogsListAPI(currentPage, pageSize);
    // Update state with fetched logs if needed
  }, [pageSize, currentPage]);

  const { openModal, closeModal } = useModal();

  const handleOpenModal = (batchId, status, totalRecords) => {
    if (totalRecords === 0) {
      showAlert({
        type: 'error',
        message: 'No Data Found for this Batch Id',
      });
      return;
    } else if (totalRecords > 0) {
      openModal(
        <DetailTable
          closeModal={closeModal}
          batchId={batchId}
          status={status}
        />,
        'Logs',
      );
    }
  };

  const columns = [
    { header: 'Batch Id', field: 'batchId' },
    { header: 'File Name', field: 'fileName' },
    {
      header: 'Total',
      render: (log) => (
        <span
          className={`${log.totalRecords > 0 ? 'cursor-pointer' : 'cursor-not-allowed'}`}
          onClick={() => handleOpenModal(log.batchId, 'All', log.totalRecords)}
        >
          <div>{log.totalRecords}</div>
        </span>
      ),
      field: 'totalRecords',
    },
    {
      header: 'Sent',
      render: (log) => (
        <span
          className={`${log.sentRecords > 0 ? 'cursor-pointer' : 'cursor-not-allowed'}`}
          onClick={() => handleOpenModal(log.batchId, 'Sent', log.sentRecords)}
        >
          <div>{log.sentRecords}</div>
        </span>
      ),
      field: 'sentRecords',
    },
    {
      header: 'Pending',
      render: (log) => (
        <span
          className={`${log.pendingRecords > 0 ? 'cursor-pointer' : 'cursor-not-allowed'}`}
          onClick={() =>
            handleOpenModal(log.batchId, 'Pending', log.pendingRecords)
          }
        >
          <div>{log.pendingRecords}</div>
        </span>
      ),
      field: 'pendingRecords',
    },
    {
      header: 'Fail',
      render: (log) => (
        <span
          className={`${log.failedRecords > 0 ? 'cursor-pointer' : 'cursor-not-allowed'}`}
          onClick={() =>
            handleOpenModal(log.batchId, 'Failed', log.failedRecords)
          }
        >
          <div>{log.failedRecords}</div>
        </span>
      ),
      field: 'failedRecords',
    },
  ];

  return (
    <Container title="Email Logs">
      <div className="font-700 text-2xl text-center">
        Email Notification Details (Payment Reminder)
      </div>
      <Table
        isForSorting={false}
        data={logData}
        columns={columns}
        pageSize={pageSize}
        totalElements={totalElements}
        currentPage={currentPage}
        onPageChange={(newPage) => setCurrentPage(newPage)}
      ></Table>
    </Container>
  );
};

const App = () => (
  <ModalProvider>
    <EmailLogs />
  </ModalProvider>
);

export default App;
